export default "/react/logoBotfaqtor-a173c13f.png";